import './App.css';
import YearPicker from './components/YearPicker.js';
import ImgContainer from './components/ImgContainer.js';
import IndiaConstituencyMap from './components/IndiaConstituencyMap';

function App() {
  return (
    <div className="App">
      <div className="site-banner">
        <img
          src="img/india-elects-banner.png"
          alt="India Elects banner"
          className="site-banner__image"
        />
      </div>
      <div className="grid-row">
        <div className="grid-column">
          <YearPicker options={[1998, 1999, 2004, 2009, 2014, 2019, 2024]} />
          <IndiaConstituencyMap />
        </div>
        <div className="grid-column">
          <YearPicker startYear={2000} endYear={new Date().getFullYear()} />
          <ImgContainer path="india-elects-banner.png" />
        </div>
      </div>
    </div>
  );
}

export default App;
